import angular from 'angular';
import ngQrcode from 'angular-qrcode';
import { AccountRoutingModule } from './account-routing.module';
import { LoginComponent } from './login.component';
import { AccountManagementModule } from './management/account-management.module';
import { ResetPasswordController } from './reset-password';
import { UserProfileModule } from './user-profile/user-profile.module';
import { AccountUserModule } from './user/account-user.module';


export const AccountModule = angular
    .module("apex.mainApp.account", [
        ngQrcode,
        AccountUserModule,
        AccountManagementModule,
        AccountRoutingModule,
        UserProfileModule
    ])
    .component("apexLogin", LoginComponent)
    .controller("ResetPassword", ResetPasswordController)
    .name
